import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({ children, className = '' }) => {
  return (
    <div className="min-h-screen">
      <div
        className={`max-w-[64rem] mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 ${className}`}
      >
        {children}
      </div>
    </div>
  );
};

export default PageContainer; 